import React, { useState } from "react";
import api from "../../api/axiosConfig";

const UploadUsersCsv = ({ setShowUpload }) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  // Modal/dialog state

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a CSV file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post(
        "http://localhost:5000/api/upload-users",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMessage(res.data.message);
    } catch (err) {
      console.error(err);
      setMessage("Error uploading file.");
    }
  };

  return (
    <div className="upload-user-dialog">
      <div className="upload-user">
        <button
          className="close-button"
          onClick={() => setShowUpload((prev) => !prev)}
        >
          ×
        </button>
        <h2 className="upload-user-heading">Upload Users CSV</h2>
        <div className="choose-csv-file-button">
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            className="choose-csv-file"
          />
          <button onClick={handleUpload} className="upload-user-button">
            Upload
          </button>
        </div>
        {message && <p className="please-select-file-text">{message}</p>}
      </div>
    </div>
  );
};

export default UploadUsersCsv;
